module.exports = __webpack_public_path__ + "static/media/giphy.6b99945a.PNG";